import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../i18n';
import { api } from '../../lib/api';

// Read-only view of organisations as the source of partner-handle data.
// Editing happens at /people (Organisations tab) — this tab is now a mirror.
const MOCK_PARTNERS = [
  { id: 'mock-org-1', name: 'UNESCO',        socialHandles: { linkedin: '@UNESCO_PL',    instagram: '@unesco_polska', facebook: '@UNESCOPolska' } },
  { id: 'mock-org-2', name: 'Europa Nostra', socialHandles: { linkedin: '@EuropaNostra', instagram: '@EuropaNostra',  facebook: '@EuropaNostra' } },
  { id: 'mock-org-3', name: 'MKiDN',         socialHandles: { linkedin: '@MKiDN_RP',     instagram: '@mkidn_rp',      facebook: '@MKiDN' } },
];

export function PartnerTagsTab() {
  const { t } = useTranslation();
  const [organisations, setOrganisations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [usingMockData, setUsingMockData] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    api.organisations
      .list()
      .then((data) => {
        if (cancelled) return;
        setOrganisations(data?.organisations ?? []);
        setUsingMockData(false);
      })
      .catch((err) => {
        if (cancelled) return;
        console.warn('[partner-tags] API unreachable, using mock data:', err.message);
        setOrganisations(MOCK_PARTNERS);
        setUsingMockData(true);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="tab-page">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 'var(--space-3)' }}>
        <p className="tab-page__intro" style={{ marginBottom: 0 }}>{t('brand.partners.intro')}</p>
        <Link to="/people" className="button button--ghost">
          {t('brand.partners.manage')}
        </Link>
      </div>

      {usingMockData && <div className="dev-notice">{t('brand.partners.loadError')}</div>}

      {isLoading ? (
        <div className="empty-state">
          <div className="empty-state__icon" aria-hidden="true">⏳</div>
          <p>{t('brand.partners.loading')}</p>
        </div>
      ) : organisations.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state__icon" aria-hidden="true">🏢</div>
          <p>{t('brand.partners.noOrgs')}</p>
        </div>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>{t('brand.partners.name')}</th>
              <th>{t('brand.partners.linkedin')}</th>
              <th>{t('brand.partners.instagram')}</th>
              <th>{t('brand.partners.facebook')}</th>
            </tr>
          </thead>
          <tbody>
            {organisations.map((org) => (
              <tr key={org.id}>
                <td><strong>{org.name}</strong></td>
                <td>{org.socialHandles?.linkedin || '—'}</td>
                <td>{org.socialHandles?.instagram || '—'}</td>
                <td>{org.socialHandles?.facebook || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
